import { iframeAppHost } from '@/util/env';

export const getUrlProtocol = (params: string) =>
  `${iframeAppHost}/open-platform/sdk/chatapp?params=${params}`;
